
import {
  useStyle 
} from "@/classify"
import Icon from "@/components/Icon"
import {
  Loader as LoaderIcon 
} from "react-feather"
import defaultClasses from "./indicator.module.css"

const LoadingIndicator = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const className = props.global ? classes.global : classes.root
  const {
    size = 64 
  } = props

  return (
    <div className={className}>
      <Icon
        src={LoaderIcon}
        size={size}
        classes={{
          icon: classes.indicator 
        }}
      />
      <span className={classes.message}>{props.children}</span>
    </div>
  )
}

export default LoadingIndicator
